module.exports = __webpack_public_path__ + "static/assets/48d57feaa42270bf5549a68c579504f9.svg";